import { PusatResolusiV2Component } from "@/app/infrastructures/dependencies/modules/PusatResolusiV2Component";
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { PusatResolusiV2Presenter } from "../presenters/PusatResolusiV2Presenter";
import { CheckTicketPusatResolusiRequest, FinishIssuePusatResolusiV2Request, ListTicketPusatResolusiRequest, SendChatPusatResolusiRequest, SubmitNotePusatResolusiRequest, GetConversationRequest, ListSTTPusatResolusi, TicketCounterPusatResolusiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { MentionsData, PusatResolusiSTT } from "@/domain/entities/PusatResolusiV2";

PusatResolusiV2Component.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "pusat-resolusi-v2"
})
class PusatResolusiV2Store extends VuexModule {
  lastSttOrShipmentNoList: PusatResolusiSTT[] = [];
  chatMessage = "";
  mentionSelected: MentionsData[] = [];
  uploadedFiles: any[] = [];
  chatMessageFinish = "";
  mentionSelectedFinish: MentionsData[] = [];
  uploadedFilesFinish: any[] = [];

  @Mutation
  public setChatMessage(val: string) {
    this.chatMessage = val;
  }

  @Mutation
  public setMentionSelected(val: any) {
    this.mentionSelected = val;
  }

  @Mutation
  public setUploadedFiles(val: any) {
    this.uploadedFiles = val;
  }

  @Mutation
  public setChatMessageFinish(val: string) {
    this.chatMessageFinish = val;
  }

  @Mutation
  public setMentionSelectedFinish(val: any) {
    this.mentionSelectedFinish = val;
  }

  @Mutation
  public setUploadedFilesFinish(val: any) {
    this.uploadedFilesFinish = val;
  }

  @Mutation
  public setLastSttOrShipmentNoList(data: PusatResolusiSTT[]) {
    this.lastSttOrShipmentNoList = data;
  }

  @Action
  public checkTicket(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkTicket(params);
  }

  @Action
  public getListCategory(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getListCategory(params);

  }

  @Action
  public getSTTList(params: {params: ListSTTPusatResolusi}) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getSTTList(params.params);
  }

  @Action
  public checkIssue(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkIssue(params);
  }

  @Action
  public followTicket(id: number) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.followTicket(id);
  }

  @Action
  public finishTicket(params: {id: number, payload: FinishIssuePusatResolusiV2Request}) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.finishIssue(params.id, params.payload);
  }
  @Action
  public getTicketDetail(id: number) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTicketDetail(id);
  }

  @Action
  public getTicketAction(id: number) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTicketAction(id);
  }

  @Action
  public submitNote(payload: SubmitNotePusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.submitNote(payload);
  }

  @Action
  public getTicketCounter(params: TicketCounterPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTicketCounter(params);
  }

  @Action
  public getListTicket(params: ListTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getListTicket(params);
  }

  @Action
  public create(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.create(params);
  }

  @Action
  public getMention(id: number ) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getMentionData(id);
  }

  @Action
  public sendChat(params: {id: number, payload: SendChatPusatResolusiRequest}) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.sendChat(params.id, params.payload);
  }

  @Action
  public getConversation(params: {id: number, params: GetConversationRequest}) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getConversation(params.id, params.params);
  }

  @Action
  public async connectConversationWebsocket(id: number): Promise<WebSocket> {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.connectConversationWebsocket(id);
  }
}

export const PusatResolusiV2Controller = getModule(PusatResolusiV2Store);
